// extracted by mini-css-extract-plugin
export default {"show__counter":"ShowCounter_show__counter__6kZwy"};